import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { Cpu, Shield, Rocket, Globe } from 'lucide-react';

export function AboutSection() {
  const stats = [
    { icon: Cpu, label: 'Digital Solutions', value: '500+' },
    { icon: Globe, label: 'Global Clients', value: '150+' },
    { icon: Shield, label: 'Years Experience', value: '15+' },
    { icon: Rocket, label: 'Innovation Awards', value: '25+' }
  ];

  return (
    <section id="about" className="py-20 relative">
      <div className="absolute inset-0 circuit-pattern opacity-10"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <Badge className="mb-4 bg-primary/20 text-primary border-primary/30 font-orbitron">
            About Diroi
          </Badge>
          <h2 className="text-4xl md:text-5xl font-orbitron font-bold text-primary mb-6">
            Shaping Digital Future
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-primary to-accent mx-auto mb-8"></div>
        </div>
        
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h3 className="text-2xl font-orbitron font-semibold text-primary mb-6">
              Our Mission
            </h3>

            

          <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <div className="mt-1 w-2 h-2 bg-primary rounded-full"></div>
                <span className="text-foreground">
                  Developing And Maintainning An Enormous Ecosystems Integrated One and Another Yet Also Modular.
                </span>
              </div>

              <div className="flex items-start space-x-3">
                <div className="mt-1 w-2 h-2 bg-primary rounded-full"></div>
                <span className="text-foreground">
                Develope Hard-Skill and Soft-Skill For All Teams To Reach Quality over Quantity
                </span>
              </div>

              <div className="flex items-start space-x-3">
                <div className="mt-1 w-2 h-2 bg-primary rounded-full"></div>
                <span className="text-foreground">
                Collaborate With Education Academy or Organization To Explore More Possibility And Oportunity
                </span>
              </div>
          </div>
        </div>
          
          <Card className="p-8 bg-card/50 backdrop-blur border-primary/20 tech-glow">
            <h3 className="text-2xl font-orbitron font-semibold text-primary mb-6">
              Our Vision
            </h3>
            <p className="text-lg text-muted-foreground mb-6 leading-relaxed">
            Become A Market Lead Company In Automation Technology And Integrated System
            By Embracing local potention of Resources And Human Resources To Lift Up Lots of Small To Big Conventional Companies
            And All Its Entities To The Next Level.
            </p>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-accent rounded-full"></div>
                <span className="text-foreground">Advanced Data Analytics</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-secondary rounded-full"></div>
                <span className="text-foreground">Smart Automation Solutions</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-primary rounded-full"></div>
                <span className="text-foreground">Digital Transformation Leadership</span>
              </div>
            </div>
          </Card>
        </div>
        
        {/* Stats Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <Card key={index} className="p-6 text-center bg-card/30 backdrop-blur border-primary/20 hover:border-primary/40 transition-all duration-300 hover:tech-glow">
                <Icon className="w-8 h-8 text-primary mx-auto mb-4" />
                <div className="text-2xl md:text-3xl font-orbitron font-bold text-primary mb-2">
                  {stat.value}
                </div>
                <div className="text-sm text-muted-foreground">
                  {stat.label}
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
}